import image1 from './tour-1.jpeg'
import image2 from './tour-2.jpeg'
import image3 from './tour-3.jpeg'
import image4 from './tour-4.jpeg'
import image5 from './tour-5.jpeg'
import image6 from './tour-6.jpeg'

export const Images = [
  {
    id: 1,
    img: image1,
    link: 'https://www.youtube.com/embed/2ft1P9O_YGc?autoplay=1',
  },
  {
    id: 2,
    img: image2,
    link: 'https://www.youtube.com/embed/xxQA0969Yf8?autoplay=1',
  },
  {
    id: 3,
    img: image3,
    link: 'https://www.youtube.com/embed/72__Mdioty8?autoplay=1',
  },
  {
    id: 4,
    img: image4,
    link: 'https://www.youtube.com/embed/gTEXJsw62iU?autoplay=1',
  },
  {
    id: 5,
    img: image5,
    link: 'https://www.youtube.com/embed/q7zdJ-nMrlE?autoplay=1',
  },
  {
    id: 6,
    img: image6,
    link: 'https://www.youtube.com/embed/s9tz9TIhbk0?autoplay=1',
  },
]
